import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSEO, BUSINESS_SCHEMA } from '../data/seo';
export const useSEO = () => {
 const { pathname } = useLocation();
 useEffect(() => {
  const page = getSEO(pathname);
  document.title = page.title;
  const set = (selector, tag, attrs) => {
   let el = document.head.querySelector(selector);
   if (!el) { el = document.createElement(tag); document.head.appendChild(el); }
   Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
   return el;
  };
  set('meta[name="description"]', 'meta', { name: 'description', content: page.description });
  set('meta[name="robots"]', 'meta', { name: 'robots', content: page.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large' });
  if (page.noindex) document.head.querySelector('link[rel="canonical"]')?.remove();
  else set('link[rel="canonical"]', 'link', { rel: 'canonical', href: page.url });
  for (const [key, content] of Object.entries({ title: page.title, description: page.description, url: page.url, image: page.image, type: page.type || 'website', site_name: 'GrowMyRestro' })) {
   set(`meta[property="og:${key}"]`, 'meta', { property: `og:${key}`, content });
  }
  for (const [key, content] of Object.entries({ card: 'summary', title: page.title, description: page.description, image: page.image })) {
   set(`meta[name="twitter:${key}"]`, 'meta', { name: `twitter:${key}`, content });
  }
  if (page.path === '/') set('#business-schema', 'script', { id: 'business-schema', type: 'application/ld+json' }).textContent = JSON.stringify(BUSINESS_SCHEMA);
  else document.getElementById('business-schema')?.remove();
 }, [pathname]);
};
